module.exports = __webpack_public_path__ + "img/avatarUrl.fd6016b2.png";